import chain from 'chain-function';
import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import setStyles from 'dom-helpers/style';
import PropTypes from 'prop-types';
import React from 'react';
import Portal from 'react-overlays/Portal';
import Transition from 'react-transition-group/Transition';
import BaseDropdownList from 'react-widgets/lib/DropdownList';

import Responsive from './Responsive';

import formStyles from './FormControl.module.scss';

const DURATION = 200;
const styles = require('./DropdownList-styles.module.scss');

const transitionClasses = {
  entering: styles.entering,
  exiting: styles.exiting,
  exited: styles.exited,
};

const reflow = node => {
  // node.style.display = 'block';
  node.offsetHeight; // eslint-disable-line
};

const stopBodyScroll = node => {
  setStyles(node.ownerDocument.body, 'overflow', 'hidden');
};
const resetBodyScroll = node => {
  setStyles(node.ownerDocument.body, 'overflow', '');
};

const GrowTransition = ({ children, className, dropUp: _, ...props }) => {
  const child = (status, innerProps) => (
    <div
      {...innerProps}
      className={classNames(
        className,
        styles.container,
        transitionClasses[status],
        !props.in && styles.hide,
      )}
    >
      <div className={styles.transition}>{children}</div>
    </div>
  );

  return (
    <Responsive smDown>
      {matches =>
        matches ? (
          <Portal>
            <Transition
              {...props}
              appear
              onEnter={chain(stopBodyScroll, reflow, props.onEnter)}
              onExiting={chain(resetBodyScroll, props.onExiting)}
              timeout={DURATION}
            >
              {child}
            </Transition>
          </Portal>
        ) : (
          <Transition
            {...props}
            onEnter={chain(reflow, props.onEnter)}
            timeout={DURATION}
          >
            {child}
          </Transition>
        )
      }
    </Responsive>
  );
};

const propTypes = {
  theme: PropTypes.oneOf(['primary', 'secondary']),
};

const defaultProps = { theme: 'primary' };

function DropdownList(
  { theme, className, containerClassName, meta, invalid, ...props },
  ref,
) {
  let isInvalid = invalid;
  if (isInvalid == null && meta) isInvalid = meta.invalid;

  return (
    <BaseDropdownList
      {...props}
      ref={ref}
      className={className}
      popupTransition={GrowTransition}
      containerClassName={classNames(
        containerClassName,
        formStyles[theme],
        isInvalid && formStyles.invalid,
      )}
    />
  );
}

export default Object.assign(React.forwardRef(DropdownList), {
  propTypes,
  defaultProps,
});
